import { CommonSettingsProps } from 'approot/activity-builder/activity-builder.constants';
import { ComponentEquationResponse } from '../component.constants';
import type { InteractiveLessonSectionFragment } from '../../lesson-builder.graphql.generated';
import type { Pluck } from 'lib/gql/pluck';

type BaseProps = Omit<ComponentEquationResponse, '__typename'>;
export type ViewProps = BaseProps;
export type EditProps = ViewProps & { contentId: number };
export type SettingsProps = EditProps & CommonSettingsProps;
export type PrintProps = BaseProps;

export const OPERATION_FIELD = 'operationField';
export const LAYOUT_FIELD = 'layoutField';
export const MORE_INFORMATION_FIELD = 'moreInformation';
export const FIRST_OPERAND_FIELD = 'firstOperand';
export const SECOND_OPERAND_FIELD = 'secondOperand';
export const ANSWER_FIELD = 'answer';
export const ERROR_ELEMENT_ID = 'invalid-response';

export type FormDataEdit = {
  [FIRST_OPERAND_FIELD]?: string;
  [SECOND_OPERAND_FIELD]?: string;
};

export type EquationResponseProperties = Pluck<
  Extract<
    Pluck<InteractiveLessonSectionFragment, 'components'>,
    { __typename: 'ActivitiesEquationResponseComponent' }
  >,
  'properties'
>;

export const typename = 'ActivitiesEquationResponseComponent';
